import { render, staticRenderFns } from "./Hexagon.vue?vue&type=template&id=022163bb&scoped=true&"
import script from "./Hexagon.vue?vue&type=script&lang=js&"
export * from "./Hexagon.vue?vue&type=script&lang=js&"
import style0 from "./Hexagon.vue?vue&type=style&index=0&id=022163bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022163bb",
  null
  
)

export default component.exports